import { render, staticRenderFns } from "./usersItem.vue?vue&type=template&id=591eb5b8&"
import script from "./usersItem.vue?vue&type=script&lang=js&"
export * from "./usersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports